export default {
  SET_REDIRECT_PAYMENT_MODAL(state, value) {
    state.showRedirectToPaymentModal = value
  },
  SET_REDIRECT_TO_LAST_ROUTE_MODAL(state, value) {
    state.showRedirectToLastRouteModal = value
  },
  SET_PLANS(state, payload) {
    state.plans = payload
  },
  SET_CURRENT_PLAN(state, payload) {
    state.currentPlan = payload
  },
  SET_PLANS_LOADING(state, payload) {
    state.plansLoading = payload
  },
  SET_PROMO_CAMPAIGN(state, data) {
    state.promoCampaign = data
  },
}
